import { resolveDynamicComponent } from "vue";
const simplyResolveComponent = (component) => {
  return resolveDynamicComponent(component);
};
export {
  simplyResolveComponent
};
//# sourceMappingURL=simplyResolveComponent.js.map
